export default function trunc (numb) {
  const numbToString = numb.toString();
  const numbLength = numbToString.length;
  const decimalLength = numbToString.indexOf('.') + 1;
  const trunc = numbToString.substr(0, decimalLength + 2);
  return decimalLength === 0 ? Number(numbToString) : Number(trunc);
};
